import { useCreate } from '@refinedev/core';

type GenerateFactFindOptions = {
  include_sensitive_fields?: boolean;
};

export function useGenerateFactFind() {
  const { mutateAsync, error, isLoading, reset } = useCreate<GenerateFactFindOptions>();

  const generateClientFactFind = async (clientId: string, values: GenerateFactFindOptions = {}) => {
    return mutateAsync({
      resource: `clients/${clientId}/fact-finds`,
      values: {
        include_sensitive_fields: values.include_sensitive_fields,
      },
    });
  };

  const generateFamilyFactFind = async (familyId: string, values: GenerateFactFindOptions = {}) => {
    return mutateAsync({
      resource: `families/${familyId}/fact-finds`,
      values: {
        include_sensitive_fields: values.include_sensitive_fields,
      },
    });
  };

  const generateFactFind = async (
    type: 'client' | 'family',
    id: string,
    values: GenerateFactFindOptions = {},
  ) => {
    if (type === 'client') {
      return generateClientFactFind(id, values);
    } else {
      return generateFamilyFactFind(id, values);
    }
  };

  return {
    generateFactFind,
    generateClientFactFind,
    generateFamilyFactFind,
    error,
    isLoading,
    reset,
  };
}
